import React, { useState } from "react";
import { Redirect } from "react-router-dom";

import {useConfig} from '../ConfigProvider';
import { useTunnelData } from "../TunnelContext";
import { useAnalytics } from "../analytics";
import Api from "../baseApi";
import Button from "../Button";
import ButtonLoader from "../ButtonLoader";
import StyledStepFooter from '../StyledStepFooter';
import { TurnstilePendingError } from "../hooks/useTurnstile";
import './Contract.scss';

export default function SignatureModal({ sendSMSMethod }) {
  const { tunnel, setTunnel } = useTunnelData();
  const { trackContractSigned } = useAnalytics();
  const [ step, setStep ] = useState("FORM");
  const [ error, setError ] = useState(false);
  const config = useConfig();

  const sendSmsAndDealWithIt = async () => {

    setError(false);
    setStep('SMS');

    return sendSMSMethod().then( ret => {
      setError(false);
      setTunnel({ ...tunnel, sign_request: ret });
      setStep('FORM');
    })
    .catch( e => {
      console.error(e);
      setError(e instanceof TurnstilePendingError ? e.message : "Nous ne pouvons renvoyer le SMS");
      setStep("FORM");
    });

    /*setError(false);
    setStep('SMS')
    return query
    .then( (ret) => {
      setTunnel({ ...tunnel, sign_request: ret });
      setStep('FORM');
    })
    .catch( e => {
      setError('Nous ne pouvons renvoyer le SMS');
      setStep('FORM');
    })*/
  };

  const handleChange = (e) => {
    // La saisie automatique iOS depuis le SMS peut inclure des espaces
    // (code groupé "12 34" ou espace final) : on ne garde que les chiffres.
    const code = e.target.value.replace(/\D/g, "");
    setTunnel({ ...tunnel, signCode: code });
  };

  const proceedToSign = async () => {
    setStep("LOADING");
    setError(false);

    try {
      const [ signContractWithCode ] = Api.POST({
        path: '/api/vel/resamania2/end_sign_mandates',
        body: {
          tunnelUid: tunnel.uid,
          msdsId: tunnel.club.msdsId,
          tunnel: tunnel,
          endSignMandate: {
            email: tunnel.user?.email,
            code: tunnel.signCode,
            signatureRequestId: tunnel.sign_request['id']
          }
        }
      });
      await signContractWithCode;
      trackContractSigned();

      try {
        if( tunnel.sales.totalTI === 0 ) {
          await doPaymentManuelDues();
          setStep('CONFIRM')
          return;
        }
        if( !config.payByCard ) {
          await doPaymentManuelDues();
          setStep('CONFIRM')
          return;
        }
        setStep("CARD");
      } catch(e) {
        console.error(e);
        setError("La finalisation du contrat a échouée");
        setStep("FORM");
      }
    } catch(e) {
      console.error(e);
      setError("Le code SMS n'est pas valide");
      setStep("FORM");
    }
  };

  const submitCode = async (e) => {
    e.preventDefault();
    setError(false);
    await proceedToSign();
  };

  const doPaymentManuelDues = async () => {
    const [ query ] = Api.POST({
      path: '/api/vel/resamania2/payment',
      body: {
        tunnelUid: tunnel.uid,
        msdsId: tunnel.club.msdsId,
        payment: {
          saleId: tunnel.sales['@id'],
          contactId: tunnel.contactResa['@id'],
          amount: tunnel.sales.totalTI,
          clubId: tunnel.sales.clubId,
        },
        tunnel
      }
    })
    return query;
  };

  const isValid = () => {
    const p = tunnel.signCode;
    if (!p)
      return false;

    return true;
  }

  if (step === "CONFIRM")
    return <Redirect push to={'/confirmation'} />;

  if (step === "CARD")
    return <Redirect push to={'/card'} />;

  return (
    <aside className="SignatureModal">
      <h3>{config.sign.title}</h3>
      <p>{config.sign.explain}</p>
      <form onSubmit={submitCode}>
        <label>
          <div style={{display:'flex', flexDirection:'row', alignItems:'baseline'}}>
            <input autoFocus={true} type="text" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]*" value={tunnel.signCode || ""} placeholder={config.sign.placeholder} name="code" onChange={handleChange} />
            { step === "FORM" && <Button style={{border:0, margin:'auto'}} className="btn-primary" onClick={sendSmsAndDealWithIt}>{config.sign.resendCodeLabel}</Button> }
          </div>
          {!!error &&
            <span className="form-error">{config.sign.badCodeLabel}</span>
          }
        </label>
      </form>
      <StyledStepFooter>
        {error && <p style={{color:"red"}}>{error}</p>}
        { step === "LOADING" && <ButtonLoader text={config.loadingSmsCodeCheck}/>  }
        { step === "SMS" && <ButtonLoader text={config.loadingSmsCodeSend}/>  }
        { step === "FORM" && <Button variant='primary' className="btn-primary" onClick={submitCode} disabled={!isValid()}>{config.sign.signLabel}</Button>}
      </StyledStepFooter>
    </aside>
  );
}
